import React from 'react';
import { Modal, PillButton, Row, Stack } from 'library/ui';
import { BlockedCountyNotice } from './BlockedCountyNotice';

export function BlockedCountyWarningDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
    if (!open) return null;

    return (
        <Modal onClose={onClose}>
            <Stack gap="md">
                <BlockedCountyNotice />
                <Row justify="end">
                    <PillButton onClick={onClose}>OK</PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
